<div class="jumbotron">
    <div class="align-middle text-center">
        <h1 class="display-4">Loading</h1>
        <p class="lead">{{ message }}</p>
        <div class="lds-css ng-scope"><div style="width:100%;height:100%;margin: auto;" class="lds-rolling"><div></div></div></div>
    </div>
</div>